import React from 'react';
import { IconProps } from './types';

const AgentCircularIcon: React.FC<IconProps> = props => {
  const {
    width = '54',
    height = '54',
    fillColor = 'var(--blue-base)',
    fillColor1 = 'var(--lightgray-base)',
    fillColor2 = 'var(--blue-bg)',
    className
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="27" cy="27" r="27" fill={fillColor2} />
      <mask
        id="mask0_5098_7319"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="11"
        y="11"
        width="32"
        height="32"
      >
        <rect x="11" y="11" width="32" height="32" fill={fillColor1} />
      </mask>
      <g mask="url(#mask0_5098_7319)">
        <path
          d="M25.6667 39V36.3333H36.3334V26.8667C36.3334 25.5778 36.089 24.3667 35.6001 23.2333C35.1112 22.1 34.4445 21.1111 33.6001 20.2667C32.7556 19.4222 31.7667 18.7556 30.6334 18.2667C29.5001 17.7778 28.289 17.5333 27.0001 17.5333C25.7112 17.5333 24.5001 17.7778 23.3667 18.2667C22.2334 18.7556 21.2445 19.4222 20.4001 20.2667C19.5556 21.1111 18.889 22.1 18.4001 23.2333C17.9112 24.3667 17.6667 25.5778 17.6667 26.8667V35H16.3334C15.6001 35 14.9725 34.7391 14.4507 34.2173C13.9281 33.6947 13.6667 33.0667 13.6667 32.3333V29.6667C13.6667 29.1556 13.789 28.7053 14.0334 28.316C14.2779 27.9276 14.6001 27.6111 15.0001 27.3667L15.1001 25.6C15.3001 23.9778 15.7614 22.5111 16.4841 21.2C17.2059 19.8889 18.1059 18.7778 19.1841 17.8667C20.2614 16.9556 21.4725 16.2498 22.8174 15.7493C24.1614 15.2498 25.5556 15 27.0001 15C28.4667 15 29.8725 15.2498 31.2174 15.7493C32.5614 16.2498 33.7667 16.9609 34.8334 17.8827C35.9001 18.8053 36.7948 19.9164 37.5174 21.216C38.2392 22.5164 38.7001 23.9667 38.9001 25.5667L39.0001 27.3C39.4001 27.5 39.7223 27.7942 39.9667 28.1827C40.2112 28.572 40.3334 29 40.3334 29.4667V32.5333C40.3334 33.0222 40.2112 33.4556 39.9667 33.8333C39.7223 34.2111 39.4001 34.5 39.0001 34.7V36.3333C39.0001 37.0667 38.7392 37.6947 38.2174 38.2173C37.6947 38.7391 37.0667 39 36.3334 39H25.6667ZM23.0001 29.6667C22.6223 29.6667 22.3059 29.5387 22.0507 29.2827C21.7947 29.0276 21.6667 28.7111 21.6667 28.3333C21.6667 27.9556 21.7947 27.6387 22.0507 27.3827C22.3059 27.1276 22.6223 27 23.0001 27C23.3779 27 23.6947 27.1276 23.9507 27.3827C24.2059 27.6387 24.3334 27.9556 24.3334 28.3333C24.3334 28.7111 24.2059 29.0276 23.9507 29.2827C23.6947 29.5387 23.3779 29.6667 23.0001 29.6667ZM31.0001 29.6667C30.6223 29.6667 30.3059 29.5387 30.0507 29.2827C29.7947 29.0276 29.6667 28.7111 29.6667 28.3333C29.6667 27.9556 29.7947 27.6387 30.0507 27.3827C30.3059 27.1276 30.6223 27 31.0001 27C31.3779 27 31.6947 27.1276 31.9507 27.3827C32.2059 27.6387 32.3334 27.9556 32.3334 28.3333C32.3334 28.7111 32.2059 29.0276 31.9507 29.2827C31.6947 29.5387 31.3779 29.6667 31.0001 29.6667ZM19.0334 27.6C18.9445 26.2889 19.1281 25.1 19.5841 24.0333C20.0392 22.9667 20.6499 22.0609 21.4161 21.316C22.1832 20.572 23.0667 20 24.0667 19.6C25.0667 19.2 26.0667 19 27.0667 19C29.089 19 30.8392 19.6391 32.3174 20.9173C33.7947 22.1947 34.689 23.7889 35.0001 25.7C32.9112 25.6778 31.0223 25.1164 29.3334 24.016C27.6445 22.9164 26.3667 21.4889 25.5001 19.7333C25.1445 21.5333 24.3947 23.1276 23.2507 24.516C22.1059 25.9053 20.7001 26.9333 19.0334 27.6Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default AgentCircularIcon;
